
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/reciters/[reciterId]",
      function () {
        return require("private-next-pages/reciters/[reciterId]/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/reciters/[reciterId]"])
      });
    }
  